import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun} from './helpers';
import type {ExternalServiceTypeFrontend} from './tables/types';

type Props = {
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
};

export function AutologInfoBanner(props: Props) {
    const serviceCategoryNoun = getServiceNoun(props.serviceType);

    return (
        <FlashBanner type='info'>
            You have autologging enabled. Recorded {serviceCategoryNoun} calls will automatically be
            logged and won’t appear in this tab.
        </FlashBanner>
    );
}
